export default __webpack_public_path__ + "static/media/Reports_Template_ACE.ca3f067c.csv";